import { render, staticRenderFns } from "./PlanAlokasiChart.vue?vue&type=template&id=7fdaf4b7&"
import script from "./PlanAlokasiChart.vue?vue&type=script&lang=js&"
export * from "./PlanAlokasiChart.vue?vue&type=script&lang=js&"
import style0 from "./PlanAlokasiChart.vue?vue&type=style&index=0&id=7fdaf4b7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports